module.exports = __webpack_public_path__ + "img/menu_icon_cinema_selected.5e1bfe20.png";